import { render, staticRenderFns } from "./PopupUpdateData.vue?vue&type=template&id=ae5579d6"
import script from "./PopupUpdateData.vue?vue&type=script&lang=js"
export * from "./PopupUpdateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports